module.exports = __webpack_public_path__ + "img/setembro_amarelo.6c7cfc97.jpg";